/**
 * Current User Service
 *
 * Application service that resolves the authenticated user's backend profile.
 * This keeps UI/auth orchestration code decoupled from API-layer calls.
 */
import { getCurrentUser } from '@/lib';

/**
 * Load current user profile by username.
 *
 * @param username Authenticated username used by the current-user endpoint.
 * @returns Raw API user payload.
 */
export const loadCurrentUser = async (username: string) => {
  return getCurrentUser(username);
};
